import { arrayOf, oneOfType, string } from 'prop-types'

const claimType = oneOfType([arrayOf(string), string])

export default claimType
